export const TOURS_CHECKOUT_STEPS = [
  {
    label: 'Tour package',
    step: 'tours',
    isRoute: true,
    subSteps: [],
  },
  {
    label: 'Review & payment',
    step: 'purchase',
    isRoute: true,
    subSteps: [],
  },
]
